import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { Star, X } from 'lucide-react';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { API, errorText } from '../governance_v2/constants';

export const KeyKpisDialog = ({ companyId, open, onClose }) => {
  const qc = useQueryClient();
  const [keys, setKeys] = useState([]);
  const [q, setQ] = useState('');
  const settings = useQuery({ queryKey: ['materiality', 'settings', companyId], enabled: open,
    queryFn: async () => (await axios.get(`${API}/companies/${companyId}/materiality/settings`)).data });
  const options = useQuery({ queryKey: ['projects-kpi-options', companyId], enabled: open,
    queryFn: async () => (await axios.get(`${API}/companies/${companyId}/projects-kpi-options`)).data.items });
  useEffect(() => { if (settings.data) setKeys(settings.data.key_kpis); }, [settings.data]);
  const save = useMutation({
    mutationFn: async () => (await axios.put(`${API}/companies/${companyId}/materiality/settings`, { key_kpis: keys })).data,
    onSuccess: () => { toast.success('KPIs clave guardados. Se reanalizan las alertas en segundos.'); qc.invalidateQueries({ queryKey: ['materiality'] }); onClose(); },
    onError: (e) => toast.error(errorText(e)),
  });
  const names = [...new Set((options.data || []).map((o) => o.kpi_name))].filter((n) => !keys.includes(n) && n.toLowerCase().includes(q.toLowerCase()));
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg" data-testid="mat-keykpis-dialog">
        <DialogHeader><DialogTitle>KPIs clave</DialogTitle></DialogHeader>
        <p className="text-xs text-slate-500">Un KPI clave recibe importancia máxima (100) en el puntaje de materialidad.</p>
        <div className="flex flex-wrap gap-2" data-testid="mat-keykpis-selected">
          {keys.length === 0 && <span className="text-xs text-slate-400">Ninguno seleccionado.</span>}
          {keys.map((k) => (
            <button type="button" key={k} onClick={() => setKeys(keys.filter((x) => x !== k))} data-testid={`mat-keykpi-remove-${k}`}
              className="flex items-center gap-1 rounded-full bg-violet-600 px-3 py-1 text-xs text-white on-solid transition-colors hover:bg-violet-700">
              <Star className="h-3 w-3" />{k}<X className="h-3 w-3" /></button>))}
        </div>
        <Input placeholder="Buscar KPI…" value={q} onChange={(e) => setQ(e.target.value)} data-testid="mat-keykpis-search" />
        <div className="max-h-56 space-y-1 overflow-y-auto">
          {names.slice(0, 50).map((n) => (
            <button type="button" key={n} onClick={() => setKeys([...keys, n])} data-testid={`mat-keykpi-add-${n}`}
              className="block w-full rounded-lg px-3 py-1.5 text-left text-sm transition-colors hover:bg-slate-100 dark:hover:bg-slate-800">{n}</button>))}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} data-testid="mat-keykpis-cancel">Cancelar</Button>
          <Button onClick={() => save.mutate()} disabled={save.isPending} data-testid="mat-keykpis-save">Guardar</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
